import { useVoiceInput } from '../hooks/useVoiceInput';

interface VoiceInputProps {
  backendUrl: string;
  onTranscription: (text: string) => void;
  disabled?: boolean;
}

export default function VoiceInput({ backendUrl, onTranscription, disabled }: VoiceInputProps) {
  const { isRecording, toggleRecording } = useVoiceInput({ backendUrl, onTranscription });

  return (
    <button
      type="button"
      className={`voice-btn${isRecording ? ' recording' : ''}`}
      onClick={toggleRecording}
      disabled={disabled}
      aria-label={isRecording ? 'Detener grabación' : 'Hablar con RAMMUX'}
      title={isRecording ? 'Detener grabación' : 'Hablar con RAMMUX'}
    >
      {isRecording ? (
        /* Stop icon */
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <rect x="6" y="6" width="12" height="12" rx="2" />
        </svg>
      ) : (
        /* Microphone icon */
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3z" />
          <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
          <line x1="12" y1="19" x2="12" y2="22" />
        </svg>
      )}
    </button>
  );
}
